import $ from 'jquery';
import hydrateEmbeds from './hydrator';

// Hydrates a visualization/vizcan that is embedded in on its own page (for
// embedding in an iframe)
$(() => {
  hydrateEmbeds();
});
